import styles from './styles.module.css';

const Titulo = (props) => {
    
    const {
        text,
        link,
        color,
        backgroundcolor
    } = props;

    const bg = backgroundcolor
    ? (String(backgroundcolor).startsWith("#") 
        ? backgroundcolor 
        : `#${backgroundcolor}`)
    : "#ffffff"; 

    return (
        <div className={`${styles['t-container']}`}>
             {
                link ? 
                    <h2 className={`${styles['text']}`}  style={{color: color,backgroundColor: bg}}>
                        <a href={link} target={'_blank'} rel='noreferrer noopener'>
                        {text}
                        </a>
                    </h2>
                :
                    <h2 className={`${styles['text']}`} style={{ color: color ,backgroundColor: bg}}>{text}</h2>
             }
        </div>
    )
}

export default Titulo;